import { observer } from 'mobx-react';
import { ChatPage } from '@assets/component/ChatPage/ChatPage';
import { useStore, useStoreUI } from '@assets/model/Store';
import { useParams } from 'react-router-dom';
require('./DealView.css');

const DealChat = observer(() => {
    const { id } = useParams();
    const store = useStore();
    const uiStore = useStoreUI();

    return (
        <>
            <ChatPage />
        </>
    );
});

export default DealChat;
